<template>
    <div class="layout-archive-list">
        <div class="title">
            <div class="title-left">
                <Dropdown trigger="click" placement="bottom-end">
                    <div class="title-select" tabindex="0" ref="focusDiv" :class="fileSelectStatus?'select-selection':''" @focus.stop="onFocus" @blur="onBlur">
                        <div class="selected-value">
                            <a href="javascript:" @click.stop="onFileSelect(-1)">{{ archiveMenuName === ''?'管理目录':archiveMenuName  }}</a>
                            <font class="selected-font" v-if="fileSelect.length!==0">/</font>
                            <font class="selected-omit" v-if="fileSelect.length>2 || (fileSelect.length>=2 && (fileSelect[fileSelect.length-1].fileName.length + fileSelect[fileSelect.length-2].fileName.length > 20))">
                              <a href="javascript:" @click.stop="onForward">...</a>
                            </font>
                            <div class="selected-name" :key="key" v-for="(file,key) in (fileSelect.length>=2 && (fileSelect[fileSelect.length-1].fileName.length + fileSelect[fileSelect.length-2].fileName.length > 20)? fileSelect.slice(-1) : fileSelect.slice(-2))"><font class="selected-font" v-if="key !==0 ">/</font><span><a href="javascript:" :style="file.id === fileSelect[fileSelect.length-1].id?'color:#2d8cf0':''" @click.stop="onFileSelect(file.id)">{{ file.fileName }}</a></span></div>
                        </div>
                        <Icon type="ios-arrow-down ivu-select-arrow"/>
                    </div>
                    <template #list>
                        <DropdownMenu>
                            <DropdownItem @click.native="onFileSelect(-1)">{{ archiveMenuName === ''?'管理目录':archiveMenuName  }}</DropdownItem>
                            <DropdownItem :key="key" v-for="(file,key) in fileSelect" @click.native="onFileSelect(file.id)" :selected="file.id === fileSelect[fileSelect.length-1].id">{{ file.fileName }}</DropdownItem>
                        </DropdownMenu>
                    </template>
                </Dropdown>
            </div>
            <div class="title-btn">
                <div class="box-list">
                    <span class="label">查找：</span>
                    <Input prefix="ios-search" v-model="searchParams.name" clearable @on-clear="onSearch" placeholder="搜索技术参数" style="width: 210px" />
                </div>
                <Dropdown transfer-class-name="title-batch">
                    <Button class="ios-list"><Icon type="md-more" />更多</Button>
                    <template #list>
                        <DropdownMenu>
                            <DropdownItem><a href="javascript:" @click="onAddFile">新建</a></DropdownItem>
                            <DropdownItem><a href="javascript:" @click="onBatchTransfer">转移</a></DropdownItem>
                            <DropdownItem><a href="javascript:" @click="onBatchDownLoad('batch')">下载</a></DropdownItem>
                            <DropdownItem><a href="javascript:" @click="onFileDelete('')">删除</a></DropdownItem>
                        </DropdownMenu>
                    </template>
                </Dropdown>
                <Button icon="btn-upload" type="primary">上传
                    <input type="file" :ref="`dataInputer${0}`" multiple="multiple" class="file" @change="onFileDataChange($event,0)">
                </Button>
            </div>
        </div>
        <div class="table text-btn">
            <Table ref="selection" stripe="stripe" :loading="archiveLoading" :height="faultTableHeight" :columns="deviceFileColumns" :data="deviceInfoArray.content" @on-select-all="onSelectAll" @on-select-all-cancel="onSelectAllCancel" @on-select="onSelect" @on-select-cancel="onSelectCancel" @on-sort-change="onSortChange">
                <template slot-scope="{ row,index }" slot="文件名">
                  <a href="javascript:" class="file-a file-box" @click="onLookFile(row)" v-if="row.folder !== 1 && !row.visible">
                    <Icon custom="icon-image" class="select-icon" v-if="row.fileType === 'jpg' || row.fileType === 'jpeg' || row.fileType === 'png' || row.fileType === 'gif' || row.fileType === 'svg' || row.fileType === 'webp'"/>
                    <Icon custom="icon-zip" class="select-icon" v-if="row.fileType === 'zip' || row.fileType === 'rar'"/>
                    <Icon custom="icon-pdf" class="select-icon" v-if="row.fileType === 'pdf'"/>
                    <Icon custom="icon-video" class="select-icon" v-if="row.fileType === 'avi' || row.fileType === 'mp4' || row.fileType === 'wav' || row.fileType === 'mov' || row.fileType === 'flv'"/>
                    <Icon custom="icon-word" class="select-icon" v-if="row.fileType === 'doc' || row.fileType === 'docx'"/>
                    <Icon custom="icon-excel" class="select-icon" v-if="row.fileType === 'xlsx' || row.fileType === 'xls'"/>
                    <Icon custom="icon-ppt" class="select-icon" v-if="row.fileType === 'ppt' || row.fileType === 'pptx'"/>
                    <Icon custom="icon-cad" class="select-icon" v-if="row.fileType === 'dwg' || row.fileType === 'dxf' || row.fileType === 'dwf'"/>
                    <Icon custom="icon-other" class="select-icon" v-if="row.fileType !== 'jpg'
                                              && row.fileType !== 'jpeg'
                                              && row.fileType !== 'png'
                                              && row.fileType !== 'gif'
                                              && row.fileType !== 'svg'
                                              && row.fileType !== 'webp'
                                              && row.fileType !== 'zip'
                                              && row.fileType !== 'rar'
                                              && row.fileType !== 'pdf'
                                              && row.fileType !== 'avi'
                                              && row.fileType !== 'mp4'
                                              && row.fileType !== 'wav'
                                              && row.fileType !== 'mov'
                                              && row.fileType !== 'flv'
                                              && row.fileType !== 'doc'
                                              && row.fileType !== 'docx'
                                              && row.fileType !== 'xlsx'
                                              && row.fileType !== 'xls'
                                              && row.fileType !== 'ppt'
                                              && row.fileType !== 'pptx'
                                              && row.fileType !== 'dwg'
                                              && row.fileType !== 'dxf'
                                              && row.fileType !== 'dwf'"/>
                    <span>{{  row.fileName }}</span>
                  </a>
                  <a href="javascript:" class="file-a" v-if="row.folder === 1 && !row.visible" @click="onFileList(row)"><Icon custom="icon-file" class="select-icon"/>{{ row.fileName}}</a>
                  <Input v-model="deviceRename" type="textarea" ref="editor" v-if="row.visible" placeholder="输入文件名称" show-word-limit :maxlength="60" class="device-rename" @on-focus="focusFileStatus = true" @on-enter="$event.target.blur()" @on-blur="onUpdateName(row.id,index,'file')"></Input>
                </template>
                <template slot-scope="{ row }" slot="文件类型">
                  {{ row.folder === 1?'文件夹':row.fileType+'文件' }}
                </template>
                <template slot-scope="{ row }" slot="大小">
                  {{ row.folder === 1?'-':renderSize(row.fileSize) }}
                </template>
                <template slot-scope="{ row }" slot="上传时间">
                  {{ row.uploadTime.replace(/:..$/, '') }}
                </template>
                <template slot-scope="{ row,index }" slot="操作">
                  <Tooltip content="修改" placement="top">
                    <a class="btn blue" href="javascript:" @click="onDeviceRename(index)"><Icon type="md-create" :size="20"/></a>
                  </Tooltip>
                  <Tooltip content="转移" placement="top">
                    <a class="btn blue" href="javascript:" @click="onTransfer(row)"><Icon type="md-swap" :size="20"/></a>
                  </Tooltip>
                  <Tooltip content="下载" placement="top">
                    <a class="btn blue" href="javascript:" @click="onDownLoadFile(row)"><Icon type="ios-cloud-download" :size="22"/></a>
                  </Tooltip>
                  <Tooltip content="删除" placement="top">
                    <a class="btn" href="javascript:" @click="onFileDelete(row.id)"><Icon type="ios-trash" :size="22"/></a>
                  </Tooltip>
                </template>
            </Table>
        </div>
        <div class="device-list-page" v-if="deviceInfoArray.content && deviceInfoArray.content.length !== 0">
            <Page :total="deviceInfoArray.totalSize" :current="deviceInfoArray.currentPage" size="small" show-total show-sizer :page-size="deviceListParams.displayNumber" @on-change="onSearchPage" @on-page-size-change="onSearchPageSize"/>
        </div>
        <!--s: Modal 查看大图-->
        <ViewImage v-model="viewImageVisible" :imageName="imageName" :imageUrl="imageSrc"/>
        <!--e: Modal 查看大图-->
        <!--s: Modal 新增故障-->
        <Modal
            v-model="addFileVisible"
            title="新建文件夹"
            footer-hide>
            <div class="device-modal">
              <span class="label" style="width: auto">文件夹名称：<font>*</font></span>
              <Input v-model="fileParams.fileName" type="text" maxlength="20"  show-word-limit  placeholder="请输入" style="width: 300px" />
            </div>
            <div class="device-footer">
                <Button @click="addFileVisible = false;">取 消</Button>
                <Button type="primary" :loading="submitLoading" @click="onAddFileCheck">确 定</Button>
            </div>
        </Modal>
        <!--e: Modal 新增故障-->
      <!--s: 上传进度-->
      <Modal
        title="上传进度"
        v-model="speedVisible"
        footer-hide
        :mask-closable="false"
        :closable="false">
        <div class="progress-info">
          <div class="info-li" :key="key" v-for="(speed,key) in speedList">
            <span class="name">{{ speed.name }}</span>
            <span class="size">{{ (speed.size / 1024 / 1024).toFixed(2) }}M</span>
          </div>
        </div>
        <div class="progress-box">
          <div class="progress-outer">
            <div class="progress-inner">
              <div class="progress-bg" :class="completeAsync<100?'before':''" :style="'width: '+completeAsync+'%; height: 10px;'"></div>
            </div>
            <div class="progress-text">{{ completeAsync }}%</div>
          </div>
        </div>
        <div class="device-footer">
          <Button type="primary" v-if="completeAsync === 100" @click="speedVisible = false;completeAsync = 0">关闭</Button>
        </div>
      </Modal>
      <!--e: 上传进度-->

      <!--s: 导入pdf -->
      <Modal
        title="导入并转换"
        v-model="pdfModalVisible"
        width="600"
        footer-hide
        class-name="pdf-modal"
        :mask-closable="false"
      >
        <div class="pdf-body">
          <div class="pdf-title">PDF转PNG</div>
          <div class="pdf-content" v-if="!pdfAddVisible">
            <div class="pdf-con">
              <span class="name"><Icon custom="icon-pdf"></Icon>{{ pdfName }}</span>
              <span class="page" v-if="!pdfUploadStatus">共{{ pdfParams.filePageCount }}页</span>
              <span class="print">{{ !pdfUploadStatus?'解析完成':'解析中' }}</span>
            </div>
            <div class="pdf-plan">
              <Progress :percent="completePdf" />
            </div>
            <div class="pdf-btn">
              <ul>
                <li><Button type="text" :disabled="pdfUploadStatus" @click="pdfAddVisible = true;pdfUploadStatus = true" icon="ios-trash">删除</Button></li>
                <li><Button type="text" @click="choicePdfElectrical" :disabled="pdfUploadStatus" :style="pdfUploadStatus?'':'color: #2d8cf0'" :custom-icon="pdfUploadStatus?'recall-grey':'recall-blue'">重新上传</Button></li>
              </ul>
            </div>
          </div>
          <div class="pdf-add" v-if="pdfAddVisible">
            <div class="content">
              <a href="javascript:" @click="choicePdfElectrical"><Icon type="ios-add" class="icon" :size="18"/></a>
              <p class="text">上传PDF文件，最大支持30M文件</p>
            </div>
          </div>
        </div>
        <div class="pdf-page-number">
          <div class="number">{{ pdfUploadStatus?'':'总页数:'+pdfParams.filePageCount+'页&nbsp;&nbsp;&nbsp;&nbsp;' }}页码转换范围：<InputNumber :min="1" :max="pdfParams.filePageCount" v-model="pdfPageStar" :disabled="pdfUploadStatus" style="width:60px" /> <font>-</font> <InputNumber :min="1" :max="pdfParams.filePageCount" :disabled="pdfUploadStatus" v-model="pdfPageEnd" style="width:60px"/></div>
          <Button type="primary" :disabled="pdfUploadStatus" style="float:right;padding:0 35px" @click="onConvert">转换</Button>
        </div>
      </Modal>
      <!--e: 导入pdf -->
        <!--s: Modal 转移-->
        <Modal
          v-model="transferVisible"
          title="移动至"
          :width="800"
          @on-visible-change="onVisibleChange"
          footer-hide>
          <div class="transfer-search">
              <div class="box-list">
                  <Input prefix="ios-search" v-model="searchParams.name" placeholder="搜索设备、文件" style="width: 426px" />
              </div>
              <Button @click="onReset" class="left-btn">重置</Button>
              <Button type="primary" @click="onSearch" class="left-btn">搜索</Button>
          </div>
          <div class="transfer-list-box">
              <div class="list-left">
                  <ul>
                      <li @click="onArchiveStatus(1)" :class="archiveStatus === 1?'active':''"><Icon custom="list-icon"/>设备知识库</li>
                      <li @click="onArchiveStatus(2)" :class="archiveStatus === 2?'active':''"><Icon custom="list-icon"/>档案管理库</li>
                  </ul>
              </div>
              <div class="list-type" v-if="archiveStatus === 1">
                <div class="list-title" @click="onSelectDevice({})"><a href="javascript:" :class="JSON.stringify(selectArchive) === '{}'?'active':''">设备目录</a></div>
                <div class="list-item" :key="'child1'+key" v-for="(deviceList,key) in deviceArray">
                  <div class="item-thead" :style="deviceList.children.length === 0?'padding-left:24px':''">
                    <a href="javascript:">
                      <Icon  v-if="deviceList.children.length!==0" :type="deviceList.visible?'md-arrow-dropdown':'md-arrow-dropright'" class="icon icon-arrow"  @click="deviceList.visible = !deviceList.visible"/>
                      <Icon :custom="deviceList.visible && deviceList.children.length!==0?'menu-open-folder':'menu-folder'"></Icon>
                      <p :class="selectArchive.value === deviceList.value?'active':''" @click="onSelectDevice(deviceList)">{{ deviceList.label }}</p>
                    </a>
                  </div>
                  <div class="item-body" v-if="deviceList.visible">
                    <div class="item-child" :key="'child2'+key" v-for="(children,key) in deviceList.children">
                      <div class="child-thead" :style="children.children.length === 0?'padding-left:45px':''">
                        <a href="javascript:" class="href">
                          <Icon v-if="children.children.length !== 0"  @click="children.visible = !children.visible" :type="children.visible?'md-arrow-dropdown':'md-arrow-dropright'" class="icon icon-arrow" />
                          <Icon :custom="children.visible && children.children.length !== 0?'menu-open-folder':'menu-folder'"></Icon>
                          <p :class="selectArchive.value === children.value?'active':''" @click="onSelectDevice(children)">{{ children.label }}</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-type" v-if="archiveStatus === 2">
                <div class="list-title" @click="onSelectArchive({})"><a href="javascript:" :class="JSON.stringify(selectArchive) === '{}'?'active':''">管理目录</a></div>
                <div class="list-item" :key="'child1'+key" v-for="(deviceList,key) in deviceTypeList[0].children">
                  <div class="item-thead" :style="deviceList.children.length === 0?'padding-left:24px':''">
                    <a href="javascript:">
                      <Icon  v-if="deviceList.children.length!==0" :type="deviceList.visible?'md-arrow-dropdown':'md-arrow-dropright'" class="icon icon-arrow"  @click="deviceList.visible = !deviceList.visible"/>
                      <Icon :custom="deviceList.visible && deviceList.children.length!==0?'menu-open-folder':'menu-folder'"></Icon>
                      <p :class="selectArchive.value === deviceList.value?'active':''" @click="onSelectArchive(deviceList)">{{ deviceList.label }}</p>
                    </a>
                  </div>
                  <div class="item-body" v-if="deviceList.visible">
                    <div class="item-child" :key="'child2'+key" v-for="(children,key) in deviceList.children">
                      <div class="child-thead" :style="children.children.length === 0?'padding-left:45px':''">
                        <a href="javascript:" class="href">
                          <Icon v-if="children.children.length !== 0"  @click="children.visible = !children.visible" :type="children.visible?'md-arrow-dropdown':'md-arrow-dropright'" class="icon icon-arrow" />
                          <Icon :custom="children.visible && children.children.length !== 0?'menu-open-folder':'menu-folder'"></Icon>
                          <p :class="selectArchive.value === children.value?'active':''" @click="onSelectArchive(children)">{{ children.label }}</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-right" v-if="archiveStatus === 1">
                  <div class="list-title">
                    <div class="transfer-box">
                      <div class="title-left">
                        <Dropdown trigger="click" placement="bottom-end">
                          <div class="title-select">
                            <div class="selected-value">
                              <a href="javascript:" @click.stop="onTransferSelect(-1)">{{ (JSON.stringify(selectArchive)!=='{}' && selectArchive.value === -1) || JSON.stringify(selectArchive)==='{}'?'全部设备':selectArchive.label  }}</a>
                              <font class="selected-font" v-if="transferSelect.length!==0">/</font>
                              <font class="selected-omit" v-if="transferSelect.length>2 || (transferSelect.length>=2 && (transferSelect[transferSelect.length-1].fileName.length + transferSelect[transferSelect.length-2].fileName.length > 20))">
                                <a href="javascript:" @click.stop="onTransferForward">...</a>
                              </font>
                              <div class="selected-name" :key="key" v-for="(file,key) in (transferSelect.length>=2 && (transferSelect[transferSelect.length-1].fileName.length + transferSelect[transferSelect.length-2].fileName.length > 20)? transferSelect.slice(-1) : transferSelect.slice(-2))"><font class="selected-font" v-if="key !==0 ">/</font><span><a href="javascript:" :style="file.id === transferSelect[transferSelect.length-1].id?'color:#2d8cf0':''" @click.stop="onTransferSelect(file.id)">{{ file.fileName }}</a></span></div>
                            </div>
                            <Icon type="ios-arrow-down ivu-select-arrow"/>
                          </div>
                          <template #list>
                            <DropdownMenu>
                              <DropdownItem @click.native="onTransferSelect(-1)">{{ (JSON.stringify(selectArchive)!=='{}' && selectArchive.value === -1) || JSON.stringify(selectArchive)==='{}'?'全部设备':selectArchive.label  }}</DropdownItem>
                              <DropdownItem :key="key" v-for="(file,key) in transferSelect" @click.native="onTransferSelect(file.id)" :selected="file.id === transferSelect[transferSelect.length-1].id">{{ file.fileName }}</DropdownItem>
                            </DropdownMenu>
                          </template>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                  <div class="list-li">
                    <span v-if="deviceListArray.filter(item=>item.folder === 1).length === 0" class="list-data">未查询到内容</span>
                    <Spin size="large" fix v-if="spinShow"></Spin>
                    <div class="li" :key="key" v-for="(row,key) in deviceListArray" v-show="row.type !==2">
                        <a href="javascript:" class="file-a"  @click="onDeviceFileList(row)"><Icon custom="icon-file" class="select-icon"/>{{ row.name }}</a>
                    </div>
                  </div>
              </div>
              <div class="list-right" v-if="archiveStatus === 2">
                  <div class="list-title">
                    <div class="transfer-box">
                      <div class="title-left">
                        <Dropdown trigger="click" placement="bottom-end">
                          <div class="title-select">
                            <div class="selected-value">
                              <a href="javascript:" @click.stop="onTransferSelect(-1)">{{ (JSON.stringify(selectArchive)!=='{}' && selectArchive.value === -1) || JSON.stringify(selectArchive)==='{}'?'管理目录':selectArchive.label  }}</a>
                              <font class="selected-font" v-if="transferSelect.length!==0">/</font>
                              <font class="selected-omit" v-if="transferSelect.length>2 || (transferSelect.length>=2 && (transferSelect[transferSelect.length-1].fileName.length + transferSelect[transferSelect.length-2].fileName.length > 20))">
                                <a href="javascript:" @click.stop="onTransferForward">...</a>
                              </font>
                              <div class="selected-name" :key="key" v-for="(file,key) in (transferSelect.length>=2 && (transferSelect[transferSelect.length-1].fileName.length + transferSelect[transferSelect.length-2].fileName.length > 20)? transferSelect.slice(-1) : transferSelect.slice(-2))"><font class="selected-font" v-if="key !==0 ">/</font><span><a href="javascript:" :style="file.id === transferSelect[transferSelect.length-1].id?'color:#2d8cf0':''" @click.stop="onTransferSelect(file.id)">{{ file.fileName }}</a></span></div>
                            </div>
                            <Icon type="ios-arrow-down ivu-select-arrow"/>
                          </div>
                          <template #list>
                            <DropdownMenu>
                              <DropdownItem @click.native="onTransferSelect(-1)">{{ (JSON.stringify(selectArchive)!=='{}' && selectArchive.value === -1) || JSON.stringify(selectArchive)==='{}'?'管理目录':selectArchive.label  }}</DropdownItem>
                              <DropdownItem :key="key" v-for="(file,key) in transferSelect" @click.native="onTransferSelect(file.id)" :selected="file.id === transferSelect[transferSelect.length-1].id">{{ file.fileName }}</DropdownItem>
                            </DropdownMenu>
                          </template>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                  <div class="list-li">
                    <span v-if="deviceListArray.filter(item=>item.fileType === 'folder' && !item.visible).length === 0" class="list-data">未查询到内容</span>
                    <Spin size="large" fix v-if="spinShow"></Spin>
                    <div class="li" :key="key" v-for="(row,key) in deviceListArray" v-show="row.fileType === 'folder' && !row.visible">
                        <a href="javascript:" class="file-a" @click="onDeviceFileList(row)"><Icon custom="icon-file" class="select-icon"/>{{ row.name }}</a>
                    </div>
                  </div>
              </div>
          </div>
          <div class="transfer-footer">
            <Button @click="transferVisible = false;">取 消</Button>
            <Button type="primary" :disabled="archiveId==='' && archiveStatus===1" :loading="transferMoveLoading" @click="onMoveFileList">确 定</Button>
          </div>
        </Modal>
        <!--e: Modal 转移-->
    </div>
</template>
<script>
import List from './list'
export default List
</script>
<style lang="less">
@import "list";
</style>
